"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProduct = exports.Allergens = void 0;
exports.getAllergenFR = getAllergenFR;
var Allergens;
(function (Allergens) {
    Allergens["CELERY"] = "allergen_celery";
    Allergens["CRUSTACEANS"] = "allergen_crustaceans";
    Allergens["EGGS"] = "allergen_eggs";
    Allergens["FISH"] = "allergen_fish";
    Allergens["GLUTEN"] = "allergen_gluten";
    Allergens["LUPIN"] = "allergen_lupin";
    Allergens["MILK"] = "allergen_milk";
    Allergens["MOLLUSCS"] = "allergen_molluscs";
    Allergens["MUSTARD"] = "allergen_mustard";
    Allergens["NUTS"] = "allergen_nuts";
    Allergens["PEANUTS"] = "allergen_peanuts";
    Allergens["SESAME_SEEDS"] = "allergen_sesame_seeds";
    Allergens["SOYBEANS"] = "allergen_soybeans";
    Allergens["SULPHUR_DIOXIDE_SULPHITES"] = "allergen_sulphur_dioxide_sulphites";
})(Allergens || (exports.Allergens = Allergens = {}));
function getAllergenFR(allergen) {
    switch (allergen) {
        case Allergens.CELERY:
            return "Contient du céleri.";
        case Allergens.CRUSTACEANS:
            return "Contient des crustacés.";
        case Allergens.EGGS:
            return "Contient des œufs.";
        case Allergens.FISH:
            return "Contient du poisson.";
        case Allergens.GLUTEN:
            return "Contient du gluten.";
        case Allergens.LUPIN:
            return "Contient du lupin.";
        case Allergens.MILK:
            return "Contient du lait.";
        case Allergens.MOLLUSCS:
            return "Contient des mollusques.";
        case Allergens.MUSTARD:
            return "Contient de la moutarde.";
        case Allergens.NUTS:
            return "Contient des fruits à coque.";
        case Allergens.PEANUTS:
            return "Contient des arachides.";
        case Allergens.SESAME_SEEDS:
            return "Contient des graines de sésame.";
        case Allergens.SOYBEANS:
            return "Contient du soja.";
        case Allergens.SULPHUR_DIOXIDE_SULPHITES:
            return "Contient du dioxyde de soufre et des sulfites.";
    }
}
const isProduct = (object) => {
    return 'productVariations' in object;
};
exports.isProduct = isProduct;
